import { render, staticRenderFns } from "./agentPublishesNoticeDetail.vue?vue&type=template&id=31a2249a&scoped=true"
import script from "./agentPublishesNoticeDetail.vue?vue&type=script&lang=js"
export * from "./agentPublishesNoticeDetail.vue?vue&type=script&lang=js"
import style0 from "./agentPublishesNoticeDetail.vue?vue&type=style&index=0&id=31a2249a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a2249a",
  null
  
)

export default component.exports